export const BRAND_GUIDE_LANDING_PATH = '/grafisk-manual';

export function normalizeAppPathname(pathname: string): string {
  const trimmed = String(pathname || '').replace(/\/+$/, '');
  return trimmed || '/';
}

export function isBrandGuideLandingPath(pathname?: string | null): boolean {
  try {
    const resolved = typeof pathname === 'string'
      ? pathname
      : (typeof window !== 'undefined' ? window.location.pathname : '');
    return normalizeAppPathname(resolved) === BRAND_GUIDE_LANDING_PATH;
  } catch {
    return false;
  }
}
